import { registerPartials } from '@precon-tools-suite-by-shared/vue-partials';
import { App } from 'vue';

export { default as NodeDetailsHeader } from './components/NodeDetailsHeader.vue';
export { default as TagAutoComplete } from './components/TagAutoComplete.vue';

export default {
    install(app: App) {
        registerPartials(
            app,
            {
                TeamsTags: () => import('./partials/TeamsTags.vue'),
                CreateTag: () => import('./partials/CreateTag.vue'),
                UpdateTag: () => import('./partials/UpdateTag.vue'),
            },
            '@precon-tools-suite-by-shared/shared-tags-feature/partials/'
        );
    },
};
